import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { placeSetSchema } from '../schemas/place-set.schema';

/**
 * Requests the Place Sets associated with a specific vehicle
 * @param vehicleId The vehicle ID for the vehicle whose Place Sets are being requested
 * @returns The Place Sets
 */
export function getPlaceSetsVehiclesId(this: unknown, vehicleId: string) {
  const requestUrl = `${
    fleetEnvironment.resolve(this).placeSetsVehiclesUrl
  }/${vehicleId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(placeSetSchema.omit({ vehicleGroups: true })),
      })
    )
  );
}
